"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columnData = exports.subheaderData = exports.headerData = void 0;
var headerData = [{
  text: '',
  value: 'selected'
}, {
  text: 'Question Type',
  value: 'questionType'
}, {
  text: 'Answer Count',
  value: 'answerCount',
  sort: true,
  sorted: true,
  action: function action() {
    return console.log('sorted');
  }
}, {
  text: 'Question',
  value: 'question'
}, {
  text: 'Answer',
  value: 'answer'
}, {
  text: 'Classification',
  value: 'classification'
}, {
  text: 'Flag',
  value: 'flag'
}, {
  text: 'Classification Status',
  value: 'classificationStatus'
}, {
  text: 'Notes',
  value: 'notes'
}, {
  text: 'Admin',
  value: 'admin'
}];
exports.headerData = headerData;
var subheaderData = ['answer', 'classification', 'flag'];
exports.subheaderData = subheaderData;
var columnData = [{
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 31161,
  "question": "ભારતમાં પહેલા COD કોને બનાવવામાં આવ્યા છે ?",
  "subRowData": [{
    "answer": "ઓમ બિરલા",
    "classification": "",
    "flag": false
  }, {
    "answer": "બિપીન રાવત (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "એડમિરલ કર્મવીર",
    "classification": "",
    "flag": false
  }, {
    "answer": "ઉપેન્દ્ર રાવત",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 24869,
  "question": "ભારતના 47માં મુખ્ય ન્યાયાધીશ કોણ બન્યા છે ?",
  "subRowData": [{
    "answer": "રંજન ગોગોઇ",
    "classification": "",
    "flag": false
  }, {
    "answer": "અરવિંદ સિંહા",
    "classification": "",
    "flag": false
  }, {
    "answer": "સુનીલ અરોડા",
    "classification": "",
    "flag": false
  }, {
    "answer": "શરદ અરવિંદ બોબડે (correct answer)",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 23073,
  "question": "દેશના નવા ગૃહસચિવ તરીકે કોની નિયુક્તિ કરવામાં આવી છે ?",
  "subRowData": [{
    "answer": "અજય ભલ્લા (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "રોહન શર્મા",
    "classification": "",
    "flag": false
  }, {
    "answer": "કેશવ ચંદ",
    "classification": "",
    "flag": false
  }, {
    "answer": "સુનીલ અરોડા",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 21654,
  "question": "RBIના હાલના ગવર્નર કોણ છે ?",
  "subRowData": [{
    "answer": "તુષાર કપુર",
    "classification": "",
    "flag": false
  }, {
    "answer": "સંદીપ ત્યાગી",
    "classification": "",
    "flag": false
  }, {
    "answer": "રજત કિશોર",
    "classification": "",
    "flag": false
  }, {
    "answer": "શક્તિકાંત દાસ (correct answer)",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null
}, {
  "selected": "checkbox",
  "questionType": "POLL",
  "answerCount": 15154,
  "question": "Which group do you prefer?",
  "subRowData": [{
    "answer": "2NE1",
    "classification": "",
    "flag": false
  }, {
    "answer": "BLACKPINK",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14975,
  "question": "Who's the maknae of EXO?",
  "subRowData": [{
    "answer": "Suho",
    "classification": "",
    "flag": false
  }, {
    "answer": "Xiumin",
    "classification": "",
    "flag": false
  }, {
    "answer": "Sehun (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "Lay",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14969,
  "question": "2018 ஆம் ஆண்டில், அசாத் நகரிலுள்ள தில்லி பொது பள்ளியின் முதன்மையானவர் யார்?",
  "subRowData": [{
    "answer": "அலோக் மிஸ்ரா",
    "classification": "",
    "flag": false
  }, {
    "answer": "ரச்னா மொகோத்ரா (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "பிரகாஷ் ஜாவேத்கர்",
    "classification": "",
    "flag": false
  }, {
    "answer": "அருண் ஜெயிட்லி",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14897,
  "question": "متى أطلقت جريدة اليوم السابع موقعها الإخباري الإنجليزي؟",
  "subRowData": [{
    "answer": "أكتوبر 2013 (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "مايو 2013",
    "classification": "",
    "flag": false
  }, {
    "answer": "مايو 2011",
    "classification": "",
    "flag": false
  }, {
    "answer": "أكتوبر 2008",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14882,
  "question": "متى أول مرة تتنافس فيها مصر في دورة الألعاب الأولمبية الشتوية؟",
  "subRowData": [{
    "answer": "1992",
    "classification": "",
    "flag": false
  }, {
    "answer": "1980",
    "classification": "",
    "flag": false
  }, {
    "answer": "1984 (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "2018",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14841,
  "question": "¿Qué himno nacional es el más largo del mundo con un total de 6 minutos?",
  "subRowData": [{
    "answer": "Uruguay (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "Paraguay",
    "classification": "",
    "flag": false
  }, {
    "answer": "Nicaragua",
    "classification": "",
    "flag": false
  }, {
    "answer": "Guayana Francesa",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14790,
  "question": "How old is Bernie Sanders?",
  "subRowData": [{
    "answer": "77 (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "72",
    "classification": "",
    "flag": false
  }, {
    "answer": "67",
    "classification": "",
    "flag": false
  }, {
    "answer": "62",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14781,
  "question": "¿Cuánto se hunde México cada año?",
  "subRowData": [{
    "answer": "12 pulgadas (30,5 cm)",
    "classification": "travel, travel locations, mexico and central america",
    "flag": false
  }, {
    "answer": "6 pulgadas (15,20 cm)",
    "classification": "travel, travel locations, mexico and central america",
    "flag": false
  }, {
    "answer": "10 pulgadas (25,5 cm) (correct answer)",
    "classification": "travel, travel locations, mexico and central america",
    "flag": false
  }, {
    "answer": "1 pulgada (2,5 cm)",
    "classification": "travel, travel locations, mexico and central america",
    "flag": false
  }],
  "classificationStatus": true,
  "notes": null
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14776,
  "question": "Which Gospel is most concerned with the mystery of identity of the person of Jesus?",
  "subRowData": [{
    "answer": " John  (correct answer)",
    "classification": "music and audio, gospel music",
    "flag": false
  }, {
    "answer": " Matthew ",
    "classification": "music and audio, gospel music",
    "flag": false
  }, {
    "answer": " Mark ",
    "classification": "",
    "flag": false
  }, {
    "answer": " Luke ",
    "classification": "music and audio, gospel music",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14768,
  "question": "¿Cuándo se fundó la Universidad Nacional de México?",
  "subRowData": [{
    "answer": "1881",
    "classification": "education, college education : travel, travel locations, mexico and central america",
    "flag": false
  }, {
    "answer": "1551 (correct answer)",
    "classification": "education, college education : travel, travel locations, mexico and central america",
    "flag": false
  }, {
    "answer": "1661",
    "classification": "education, college education : travel, travel locations, mexico and central america",
    "flag": false
  }, {
    "answer": "1771",
    "classification": "education, college education : travel, travel locations, mexico and central america",
    "flag": false
  }],
  "classificationStatus": true,
  "notes": null
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14757,
  "question": "أين عقدت دورة الالعاب الاولمبية الشتوية عام 1984؟",
  "subRowData": [{
    "answer": "سراييفو (correct answer)",
    "classification": "sports, olympic sports, winter olympic sports",
    "flag": false
  }, {
    "answer": "بحيرة بلاسيد",
    "classification": "sports, olympic sports, winter olympic sports",
    "flag": false
  }, {
    "answer": "ناجانو",
    "classification": "sports, olympic sports, winter olympic sports",
    "flag": false
  }, {
    "answer": "كالجاري",
    "classification": "sports, olympic sports, winter olympic sports",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14741,
  "question": "2018 ஆம் ஆண்டில், ஜவஹர்லால் நேரு பல்கலைக்கழகத்தின் தலைமையதிகாரி யார்?",
  "subRowData": [{
    "answer": "அனுபம் கேர்",
    "classification": "",
    "flag": false
  }, {
    "answer": "வி.கே.சரஸ்வத் (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "ராம் வி. சுடர்",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14728,
  "question": "Who's the youngest member of TWICE?",
  "subRowData": [{
    "answer": "MoMo",
    "classification": "",
    "flag": false
  }, {
    "answer": "Mina",
    "classification": "business and finance, economy, currencies",
    "flag": false
  }, {
    "answer": "Nayeon",
    "classification": "",
    "flag": false
  }, {
    "answer": "Tzuyu (correct answer)",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14715,
  "question": "¿De qué país sudamericano es originario el papa Francisco?",
  "subRowData": [{
    "answer": "Argentina (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "Nicaragua",
    "classification": "",
    "flag": false
  }, {
    "answer": "Perú",
    "classification": "",
    "flag": false
  }, {
    "answer": "Brasil",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14707,
  "question": "¿Cuántas veces ha ganado Brasil la Copa Mundial de la FIFA?",
  "subRowData": [{
    "answer": "4",
    "classification": "events and attractions, sporting events : sports, soccer",
    "flag": false
  }, {
    "answer": "5 (correct answer)",
    "classification": "events and attractions, sporting events : sports, soccer",
    "flag": false
  }, {
    "answer": "3",
    "classification": "events and attractions, sporting events : sports, soccer",
    "flag": false
  }, {
    "answer": "2",
    "classification": "events and attractions, sporting events : sports, soccer",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14690,
  "question": "بأي جهاز يعتقد المصريون القدماء أن الله خنوم خلق كل إنسان؟",
  "subRowData": [{
    "answer": "كور الحداد",
    "classification": "events and attractions, personal celebrations and life events, funeral : family and relationships, bereavement : science, social science, history, ancient history",
    "flag": false
  }, {
    "answer": "النول",
    "classification": "business and finance, industries, textile industry : science, social science, history, ancient history",
    "flag": false
  }, {
    "answer": "عجلة الخزاف (correct answer)",
    "classification": "science, social science, history, ancient history",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "POLL",
  "answerCount": 14677,
  "question": "¿Practicas artes marciales?",
  "subRowData": [{
    "answer": "sí",
    "classification": "",
    "flag": false
  }, {
    "answer": "no",
    "classification": "",
    "flag": false
  }, {
    "answer": "ya no",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14660,
  "question": "كم عدد المرات التي اختار فيها \"فوربس الشرق الأوسط\" اليوم السابع كأفضل موقع إخباري في المنطقة؟",
  "subRowData": [{
    "answer": "أبداً",
    "classification": "",
    "flag": false
  }, {
    "answer": "ثلاث مرات",
    "classification": "",
    "flag": false
  }, {
    "answer": "مرة واحدة",
    "classification": "",
    "flag": false
  }, {
    "answer": "مرتين (correct answer)",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14637,
  "question": "¿Dónde se encuentra exclusivamente la vaquita marina?",
  "subRowData": [{
    "answer": "Golfo de México",
    "classification": "",
    "flag": false
  }, {
    "answer": "Mar Caribe",
    "classification": "",
    "flag": false
  }, {
    "answer": "Islas Galápagos",
    "classification": "",
    "flag": false
  }, {
    "answer": "Mar de Cortés (correct answer)",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}, {
  "selected": "checkbox",
  "questionType": "QUIZ",
  "answerCount": 14590,
  "question": "Who is the first disciple to deny Jesus?",
  "subRowData": [{
    "answer": "Judas",
    "classification": "",
    "flag": false
  }, {
    "answer": "Thomas",
    "classification": "",
    "flag": false
  }, {
    "answer": "Peter (correct answer)",
    "classification": "",
    "flag": false
  }, {
    "answer": "Bartholomew",
    "classification": "",
    "flag": false
  }],
  "classificationStatus": false,
  "notes": null,
  "admin": "Rohan Desai"
}];
exports.columnData = columnData;